import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  updateSettingsPayload: {}
}

export const customSettingsSlice = createSlice({
  name: 'customSettings',
  initialState,
  reducers: {
    setUpdateSettingsPayload: (state, action) => {
      state.updateSettingsPayload = action.payload
    },
    resetUpdateSettingsPayload: (state) => {
      state.updateSettingsPayload = {}
    },
    resetCustomSettings: () => initialState
  }
})

export const {setUpdateSettingsPayload, resetUpdateSettingsPayload, resetCustomSettings} = customSettingsSlice.actions

// Selectors
export const selectUpdateSettingsPayload = (state) => state.customSettings.updateSettingsPayload

export default customSettingsSlice.reducer
